// Politique de confidentialité.
//
// Écrite à partir de ce que la base contient RÉELLEMENT (voir les
// migrations) et des sous-traitants réellement appelés. Sur un produit qui
// promet « on ne lit pas ton historique », une politique copiée-collée qui
// mentionnerait des traitements inexistants — ou en oublierait un — vaudrait
// pire que rien.
import LegalShell from '../../components/urself/LegalShell'
import { COMPANY, PROCESSORS } from '../../lib/legal'
import { useT } from '../../lib/i18n'

export default function Privacy () {
  const L = useT().legal.privacy

  return (
    <LegalShell title={L.title} updated={L.updated} intro={L.intro}>
      <h2>{L.notT}</h2>
      <p>{L.notP1}</p>
      <p>{L.notP2}</p>

      <h2>{L.doT}</h2>
      <h3>{L.accountT}</h3>
      <ul>{L.accountItems.map(x => <li key={x}>{x}</li>)}</ul>

      <h3>{L.payT}</h3>
      <ul>{L.payItems.map(x => <li key={x}>{x}</li>)}</ul>

      <h3>{L.adsT}</h3>
      <ul>{L.adsItems.map(x => <li key={x}>{x}</li>)}</ul>

      <h3>{L.optT}</h3>
      <ul>{L.optItems.map((x, i) => <li key={i}>{x}</li>)}</ul>

      <h2>{L.basisT}</h2>
      <p>{L.basisP}</p>

      <h2>{L.whoT}</h2>
      <dl className="u-def">
        {PROCESSORS.map(p => {
          // Le nom est une raison sociale, la description est traduite.
          const d = L.processors[p.key]
          return (
            <div key={p.key}>
              <dt>{String(p.name).includes('REMPLIR')
                ? <span className="u-todo">{p.name}</span> : p.name}</dt>
              <dd>
                <b>{d.role}.</b> {d.data}. {L.hosting(d.where)}
              </dd>
            </div>
          )
        })}
      </dl>
      <p>{L.transferP}</p>

      <h2>{L.keepT}</h2>
      <ul>{L.keepItems.map(x => <li key={x}>{x}</li>)}</ul>

      <h2>{L.rightsT}</h2>
      <p>
        {L.rightsP1}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
        {L.rightsP2}
      </p>
      <p>{L.rightsP3}</p>

      <h2>{L.cookiesT}</h2>
      <p>{L.cookiesP}</p>

      <h2>{L.secT}</h2>
      <p>{L.secP}</p>
    </LegalShell>
  )
}
